export function error(state, error) {
  (state.error = true), (state.errorMessage = error);
}

export function cleanErrors(state) {
  state.complete = false;
  state.completeMessage = '';
  (state.error = false), (state.errorMessage = '');
}

export function correctComplete(state, message) {
  state.complete = true;
  state.completeMessage = message;
}

export function saveModulesList(state, data) {
  data.forEach((element) => {
    element['img'] = 'modules-0' + element.order;
    element['alt'] = element.name + ' icon';
  });
  state.modulesList = data;
}
